export const heartsUrl = '/hearts/';
